<template>
  <div>
    <div id="container">
      <div class="blog">
        <div class="title-blog" style="width:100%">REWARD</div>
        <div class="header-blog">
          <div style="width:30%">
            <div class="searchContainer" style="margin-top:5px;width:100%">
              <i class="md-icon material-icons searchIcon">search</i>
              <input
                v-model="search"
                class="searchBox"
                type="search"
                name="search"
                placeholder="Search rewards."
                v-on:input="searchRewards"
              >
            </div>
          </div>
          <div style="width:5%">
            <md-button
              style="margin-left:15px"
              class="md-icon-button"
              :class="{'md-accent':(filterStatus || filterType)? true:false}"
              @click="openFilter"
            >
              <md-icon class="filter">filter_list</md-icon>
            </md-button>
          </div>
          <div style="width:65%;text-align: -webkit-right;">
            <md-button class="md-raised md-primary btn-create" @click="createReward()" v-if="permit.acl['campaign'].menus['reward'].add">
              <i class="md-icon material-icons" style="margin-right:5px;font-size:10px">add</i>Create
            </md-button>
          </div>
        </div>
        <div class="table-blog">
          <div style="position: absolute;top: 45%; left: 50%; width: 10%; z-index: 2;" v-show="loading == true">
            <md-progress-spinner :md-stroke="8" :md-diameter="65" md-mode="indeterminate"></md-progress-spinner>
          </div>
          <div class="head-table">
             <div class="col" style="width :10%">Reward</div>
             <div class="col" style="width :26%"></div>
             <div class="col" style="width :11%;text-align:right">Value</div>
             <div class="col" style="width :11%;text-align:right">Redeemed</div>
             <div class="col" style="width :11%;text-align:right">In-Stock</div>
             <div class="col" style="width :18%;text-align:center">Create by</div>
             <div style="width :8%;text-align:center">Status</div>
             <div style="width :5%;text-align: -webkit-center;"></div>
          </div>
           <div class="body-table">
            <div class="row-table" v-for="(item , index) in rewards" :key="'row-table-'+index" @click="showDetail(item)">
              <div class="col" style="width :10%">
                <img class="product-image" :src="item.image">
              </div>
                <div class="col top-line" style="width :26%;font-family:kanit;word-wrap: break-word;">
                {{ item.name }}
                {{ item.description }}
              </div>
              <div class="col top-line" style="width :11%;text-align:right">{{ item.value.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</div>
              <div class="col top-line" style="width :11%;text-align:right">{{ item.redeemed }}</div>
              <div class="col top-line" style="width :11%;text-align:right">{{ item.in_stock.toLocaleString(undefined, {minimumFractionDigits: 0}) }}</div>
              <div class="col top-line" style="width :18%;text-align:center">{{ item.create_by }}</div>
              <div class="top-line" style="width :8%;text-align: -webkit-center;"><div class="badge" style="font-family:roboto">LIVE</div></div>
              <div class="top-line" style="width :5%;text-align: -webkit-center;"> <md-icon>info_outline</md-icon></div>
            </div>
          </div>
          <div class="footer-table">number of lines in page ({{rewards.length}})</div>
        </div>
     </div>
    </div>
    <md-dialog
      :md-active.sync="showDialogCreate"
      id="dialog-create-reward"
      @md-closed="clearImage"
      @md-opened="openDialog"
    >
      <md-dialog-title>
        <div class="title-from" style="padding-top:20px">{{titleForm}}</div>
        <div style="width:50%;text-align: -webkit-right;">
          <md-button v-if="mode == 'view'&&  isOwner && permit.acl['campaign'].menus['reward'].edit==true" 
              class="md-primary" @click="editReward()" style="margin-top:10px;margin-right:0px">EDIT</md-button>
          <md-menu md-size="small" style="margin-top:7px"
            v-if="isOwner && (permit.acl['campaign'].menus['reward'].edit==true || permit.acl['campaign'].menus['reward'].delete==true)">
             <md-button class="md-icon-button" md-menu-trigger>  
              <md-icon style="color:black">more_vert</md-icon>
            </md-button>
            <md-menu-content style="z-index: 2000;">
              <!-- 
              <md-menu-item @click="editReward()" v-if="permit.acl['campaign'].menus['reward'].edit==true">
                <span>Edit</span>
              </md-menu-item> -->
              <md-menu-item @click="deleteReward()" v-if="permit.acl['campaign'].menus['reward'].delete==true">
                <span>Delete</span>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
      
      </md-dialog-title>
      <md-dialog-content>
      <!-- <md-dialog-content style="overflow:hidden"> -->
        <div class="md-layout">
          <div class="md-layout-item add-mode" v-if="mode != 'view'">
            <form novalidate>
              <div class="add-mode-label"><b>Name</b></div>
              <md-field :class="getValidationClass('Name')" md-inline class="add-mode-feild">
                <label class="add-mode-feild-label">Name</label>
                <md-input v-model="form.Name" style="height: 25px;"></md-input>
                <div class="md-error" v-if="!$v.form.Name.required">Field is required</div>
              </md-field>
              <div class="add-mode-label"><b>Description</b></div>
              <md-field md-inline class="add-mode-feild">
                <label class="add-mode-feild-label">Description</label>
                <md-input v-model="form.Description" style="height: 25px;"></md-input>
              </md-field>
              <div class="add-mode-label"><b>Value (Price)</b></div>
              <md-field md-inline class="add-mode-feild">
                <label class="add-mode-feild-label">Value (Price)</label>
                <md-input v-model="form.Value" type="text" @keypress.native="isNumber" style="height: 25px;"></md-input>
              </md-field>
              <div class="add-mode-label"><b>In-Stock</b></div>
              <md-field md-inline class="add-mode-feild">
                <label class="add-mode-feild-label">In-Stock</label>
                <md-input v-model="form.InStock" type="text" @keypress.native="isNumber" style="height: 25px;"></md-input>
              </md-field>
              <div class="add-mode-label"><b>Type</b></div>
              <md-field style="margin:0px 0px 10px 0px;padding-top: 0px;min-height: 25px;">
                <md-select v-model="form.Type" >
                  <md-option value="">Please select type</md-option>
                  <md-option v-for="item in optionType" :value="item.value">{{item.title}}</md-option>
                </md-select>
              </md-field>
            </form>
          </div>
          <div class="md-layout-item view-mode" v-else >
            <div class="view-mode-label"><b>Name</b></div>
            <div class="view-mode-value" style="font-family:Kanit">{{form.Name}}</div>
            <div class="view-mode-label"><b>Description</b></div>
            <div class="view-mode-value" style="font-family:Kanit;width: 250px;word-wrap: break-word;"
                  >{{form.Description}}</div>
            <div class="view-mode-label"><b>Value (Price)</b></div>
            <div class="view-mode-value">{{form.Value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</div>
            <div class="view-mode-label"><b>In-Stock</b></div>
            <div class="view-mode-value">{{form.InStock.toLocaleString(undefined, {minimumFractionDigits: 0})}}</div>
            <div class="view-mode-label"><b>Type</b></div>
            <div class="view-mode-value" style="margin-bottom: 0px;">{{displayType(form.Type)}}</div>
          </div>
          <div class="md-layout-item" style="padding-top:20px;padding-left:30px;text-align: -webkit-center;">
            <div
              @click="addFile()"
              ref="image-button"
              class="reword-upload-image"
            >
              <span v-if="form.Image==null">IMAGE UPLOAD</span>
              <input
                type="file"
                accept="image/*"
                name="files"
                ref="files"
                class="inputfile"
                @change="handleFileUploads($event)"
              >
              <div
                v-if="form.Image!=null && mode != 'view'"
                style="position:absolute;top:10px;right:10px;"
                @click.stop="removeImage();"
              >
                <md-icon style="color:white;">close</md-icon>
              </div>
            </div>
            <div
              class="reword-remark-upload"
              style="font-size:10px;margin-left:30px;"
            >Recommended image size: 300 x 300px</div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions style="padding-right:30px;font-family:lato">
        <md-button class="" @click="showDialogCreate = false" style="color: #727272;">
          <b><span v-if="mode!='view'">Cancel</span><span v-else>Close</span></b>
        </md-button>
        <md-button v-if="mode=='edit'" class="md-primary" @click="updateReward()"><b>Update</b></md-button>
        <md-button v-if="mode=='create'" class="md-primary" @click="saveReward()"><b>Create</b></md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-confirm
      :md-active.sync="dlgConfirmDelete"
      md-title="Delete Reward?"
      md-content="Are you sure?"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmDelete"
    />

    <md-dialog-alert
      :md-active.sync="dlgAlert"
      :md-title="dlgTitle"
      :md-content="dlgMessage" />

      <dialogFilter
        v-if="filterdata == true"
        ref="dialogFilter"
        :title="'Filter Reward'"
        @clickFilter="onClickFilter"
        @clickCancel="onClickCancel"
      ></dialogFilter>

  </div>
</template>

<script>
import rewardService from "@/services/reward.js";
import rewardInfo from "@/components/campaign/reward/reward.info";
import dialogFilter from "./reward/dialog-filter";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "reward-page",
  mixins: [validationMixin],
  components: {
    rewardInfo,
    dialogFilter: dialogFilter
  },
  data() {
    return {
      mode: "create",
      showDialogCreate: false,
      showDialogFilter: false,
      loading: false,
      dlgConfirmDelete: false,
      titleForm: "CREATE A NEW REWARD",
      titlePanel: "",
      filterStatus: "",
      optionStatus: ["Live", "Offline"],
      filterType: "",
      optionType: [{value:"Internal",title:"Goods of siamwalla"},{value:"External",title:"Non goods of siamwalla"}],
      search: "",
      form: {
        id: null,
        Name: null,
        Description: null,
        Value: 0,
        Type: "Internal",
        InStock: 0,
        Image: null
      },
      rewards: [],
      selectedReward: {},
      dlgAlert: false,
      dlgTitle: "",
      dlgMessage: "",
      filterdata: false,
    };
  },
  validations: {
    form: {
      Name: {
        required
      }
    }
  },
  created() {
    this.loadRewards();
  },
  computed: {
		permit() {
			return this.$jwt.decode(localStorage.getItem("token"));
    },
    isOwner(){
      if (this.permit.username == this.selectedReward.create_by) return true;
      else return false;
    }
  },
  methods: {
    displayType(value){
      let rs = ''
      this.optionType.forEach(element => {
        if(element.value == value){
          rs =  element.title;
        }
      });
      return rs;
    },
    openFilter() {
      this.filterdata = true;
    },
    onClickFilter(value) {
      this.filterdata = false;
    },
    onClickCancel() {
      this.filterdata = false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        this.keepEvent = false;
        evt.preventDefault();
      } else {
        this.keepEvent = true;
        return true;
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    loadRewards() {
      this.loading = true
      rewardService.getAllReward().then(response => {
        this.rewards = response;
        this.loading = false
      });
    },
    someHandler() {
      console.log(this.search);
    },
    clearForm() {
      this.form = {
        id: null,
        Name: "",
        Description: "",
        Value: 0,
        Type: "Internal",
        InStock: 0,
        Image: null
      };
    },
    createReward() {
      this.clearForm();
      this.mode = "create";
      this.titleForm = "CREATE A NEW REWARD";
      this.showDialogCreate = true;
    },
    showDetail(item) {
      this.selectedReward = item;
      this.mode = "view";
      this.titleForm = "INFORMATION";
      this.form.id = item._id;
      this.form.Name = item.name;
      this.form.Description = item.description;
      this.form.Value = item.value;
      this.form.Type = item.type;
      this.form.InStock = item.in_stock;
      this.form.Image = item.image;
      this.showDialogCreate =  true;
      // this.setImageUpload(this.form.Image);

    },
    addFile() {
      this.$refs.files.click();
    },
    handleFileUploads(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      let size = files[0].size;
      let sizeInKb = size / 1024;
      this.createImage(files[0]);
    },
    createImage(file, index) {
      var tempImage = new Image();
      var reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        tempImage = e.target.result;

        this.form.Image = tempImage;

        this.setImageUpload(tempImage);
      };
      reader.readAsDataURL(file);
    },
    setImageUpload(image) {
      var imageButton = this.$refs["image-button"];

      imageButton.style.backgroundImage = "url('" + image + "')";
      imageButton.style.backgroundRepeat = "no-repeat";
      imageButton.style.backgroundPosition = "center center";
      imageButton.style.backgroundSize = "100%";
    },
    removeImage() {
      this.form.Image = null;
      var imageButton = this.$refs["image-button"];
      imageButton.style.backgroundImage = "none";

      this.$refs.files.value = null;
    },
    clearImage() {
      this.$v.$reset();
      this.form.Image = null;
    },
    saveReward() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        rewardService.createReward(this.form).then(response => {
          this.loadRewards();
          this.showDialogCreate = false;

          this.form = {
            Name: "",
            Description: "",
            Value: 0,
            Type: "Internal",
            InStock: 0,
            Image: null
          };
        });
      }
    },
    searchRewards() {
      rewardService.searchReward(this.search).then(response => {
        this.rewards = response;
      });
    },
    editReward() {
      this.titleForm = "EDIT REWARD";
      this.mode = "edit";
      let id = this.selectedReward._id;
      rewardService.getOneReward(id).then(response => {
        let data = response[0];
        this.form.id = data._id;
        this.form.Name = data.name;
        this.form.Description = data.description;
        this.form.Value = data.value;
        this.form.Type = data.type;
        this.form.InStock = data.in_stock;
        this.form.Image = data.image;
        this.setImageUpload(this.form.Image);
        // this.showDialogCreate = true;
      });
    },
    deleteReward() {
      this.dlgConfirmDelete = true;
    },
    onConfirmDelete() {
      let id = this.selectedReward._id;
      rewardService.deleteReward(id).then(response => {
        this.loadRewards();
      }).catch(err=>{
        this.dlgTitle = "Delete error!";
        this.dlgMessage = err.response.data.message;
        this.dlgAlert = true;
      });
    },
    updateReward() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        rewardService.updateReward(this.form).then(response => {
          this.showDialogCreate = false;
          this.loadRewards();
        });
      }
    },
    openDialog() {
      if (this.mode == "edit" || this.mode == "view") this.setImageUpload(this.form.Image);
    }
  }
};
</script>

<style lang="scss" scoped>
#reward-page {
  background: white;
}
#container {
  .blog {
    background: white;
    padding-left:10px;
    .title-blog{
      padding-left:30px;
      font-size: 18px;
      font-weight: bold;
      color: #797979;
      font-family : lato; 
      padding-top:20px;
    }
    .header-blog {
      padding: 18px 30px 20px 30px;
      display :-webkit-box; 
      width:100%;
      .btn-create {
        width: 120px;
        height: 32px;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        font-family: lato;
        font-size: 12px;
        font-weight: 700;
        border-radius: 3px;
        .plus {
          margin-right: 20px;
        }
      }
      .md-button.md-raised:not([disabled]){
        box-shadow:unset;
      }
    }
    .table-blog {
      width:100%;
      padding-left:5px;
      padding-right:5px;
      // padding: 0px 30px 30px 30px;
      .col {
        padding-right:10px;
        // padding-left:20px;
      }
      .head-table {
        margin-bottom : 25px;
        display :-webkit-box; 
        font-size : 13px;
        font-family : lato; 
        font-weight:bold;
        padding-left:25px;
        padding-right:25px;
      }
      .body-table {
        height: calc(100vh - 215px);
        overflow-y:scroll;
        overflow-x:hidden;
        .row-table {
          padding-left:25px;
          padding-right:20px;
          display :-webkit-box; 
          font-family: lato;
          font-size : 13px;
          margin-bottom: 10px;
          .top-line {
            padding-top:10px;
          }
        }
        .row-table:hover{
           background: rgba(236, 236, 235, 1);
           cursor: pointer;
           border-radius:3px;
        }
      }
      .body-table::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
    .footer-table {
      display: block;
      text-align: center;
      margin-top: 5px;
      padding-bottom: 20px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
  }

  .content {
    float: left;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  // .right{
  //     float: right;
  //     width:35%;
  //     height: 100%;
  //     padding-left:20px;
  //     overflow: auto;
  // }
  .footer {
    clear: both;
  }

  .searchContainer {
    display: inline-flex;
    flex: 1 1 300px;
    position: relative;
    // border: 1px solid #c0c0c0;
    border-radius: 5px;
    overflow: hidden;
    width: 360px;
    height: 36px;
    .md-icon {
      color: #c0c0c0 !important;
    }
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
      0 1px 1px -2px rgba(0, 0, 0, 0);
    .searchIcon {
      padding-left: 20px;
      width: 40px;
    }

    .searchBox {
      font-size: 14px;
      border: 0;
      padding: 0.5rem 0.5rem 0.5rem 10px;
      flex: 1;
      outline: none;
      &::-webkit-input-placeholder {
        color: #c0c0c0;
      }
      &::-ms-clear {
        display: none;
      }
    }
  }

  .product-image {
    width: 72px;
    height: 72px;
    background: #ccc;
    border-radius: 3px;
  }

  .md-table-row {
    cursor: pointer;
  }
  .md-table-row td {
    border-top: none !important;
  }

  .badge {
    color: white;
    text-align: center;
    background: #66bb6a;
    width: 50px;
    height: 20px;
    border-radius: 10px;
    font-weight: bold;
    padding-top: 2px;
  }

  .item-detail {
    margin-left: 20px;
    margin-bottom: 20px;
    background: #efefef;
    padding-top: 30px;
    // display: table-cell;
    height: 70px;
    width: 330px;
    vertical-align: middle;
    text-align: center;
  }
}

#reward-panel {
  width: 430px !important;
  background: white;

  .md-title {
    color: white;
  }

  .header-toolbar {
    background-color: #303f9f !important;
  }

  .sidepanel-content {
    // height: 100%;
    margin: 20px;
    margin-right: 4px;
    overflow-y: scroll;
  }

  .reward-detail {
    width: 380px;
    height: 320px;
    border: 1px solid #ccc;
    margin-bottom: 30px;
    border-top: 10px solid #3f51b5;
    padding: 10px;
  }

  .reward-summary {
    width: 380px;
    height: 320px;
    border: 1px solid #ccc;
    margin-bottom: 30px;
    border-top: 10px solid #3f51b5;
    padding: 10px;
  }
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

#dialog-create-reward {
    padding:5px 20px 20px 20px;
    width: 60%;
    height: 76%;
    // height: 500px;
    transform: unset !important;
    top: 10% !important;
    left: 20% !important;
    .md-dialog-title {
      width:100%;
      display: -webkit-box;
      padding-top:10px;
      .title-from {
        width:50%;
        font-family: lato;
        font-size: 18px;
        font-weight: 700;
      }
    }
    .md-dialog-content {
      overflow-y:auto;
      overflow-x:hidden;
      .add-mode {
        .add-mode-label {
          font-size:12px;
          color:rgb(148, 148, 150);
          font-family : lato
        }
        .add-mode-feild {
          margin:0px 0px 20px 0px;
          padding-top: 0px;
          min-height: 25px;
          .add-mode-feild-label {
            top: 3px;
            font-size:15px;
            color:black;
          }
        }
      }
      .view-mode {
        font-size : 13px;
        font-family : lato;
        margin-top:10px;
        font-family: lato;
        .view-mode-label {
          padding-bottom:3px;
          font-size:12px;
          color:rgb(148, 148, 150);
        }
        .view-mode-value {
          margin-bottom:20px;
          font-size:15px
        }
      }
    }
    .md-dialog-content::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }

    .reword-upload-image {
      // background: gray;
      height: 170px;
      position:relative;
      color:white;
      width:214px;
      background:#727272;
      border-radius:4px;
      padding-top:70px;
      // padding-left:50px;
      margin-left:20px;
      margin-bottom:10px;
      cursor: pointer;
      background-color: gray;
    }
     .reword-remark-upload {
        font-size: 10px;
      }
}
</style>
